import { useTranslation } from 'react-i18next'

import { AutoEnrollmentTranslation } from '@/AutoEnrollment/ui/autoEnrollmentTranslation'
import { LogaltyPending } from '@/Logalty/ui/molecules'

export const Step5PendingScreen = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <LogaltyPending
      description={t(AutoEnrollmentTranslation.confirmationScreen.pending.description)}
    />
  )
}
